// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__389_R","detailsBorder":"styles_detailsBorder__3OQKL"};